'use client';

import { useQuery } from '@tanstack/react-query';
import { useShallow } from 'zustand/react/shallow';

import { AuthQueryOptions } from '@/api';
import { useAuthStore } from '@/stores/AuthStore';
import { useDeviceInfoStore, WEBVIEW_TYPE } from '@/stores/DeviceStore';

/**
 * 오퍼월 리워드 귀속 userId(WEL-5257) — 애드팝콘·핀크럭스 등 벤더 공용이라 특정 벤더 모듈이 아닌 공용 훅으로 둔다.
 * identityKey만 유효하다: memberOAuth는 서버에서 에러라 폴백하지 않는다(과거 폴백이 오퍼월 memberOAuth 에러의 원인).
 * null이면(비앱·미로그인·본인인증 미보유 30404·조회 실패) 소비처가 오퍼월을 열지 않는다.
 * SSP 전면광고는 리워드를 자체 인증 백엔드가 지급하므로 이 userId가 불필요하다.
 */
export const useAdUserId = (): string | null => {
  const { isMounted, webviewType } = useDeviceInfoStore(
    useShallow((state) => ({
      isMounted: state.isMounted,
      webviewType: state.webviewType,
    })),
  );
  const isReady = isMounted && webviewType === WEBVIEW_TYPE.WELLO_APP;

  const memberOAuth = useAuthStore((state) => state.myInfo?.memberOAuth);

  const { data } = useQuery({
    ...AuthQueryOptions['get:/wello/v2/auth/member-identity'](),
    enabled: isReady && !!memberOAuth,
    staleTime: Infinity,
    retry: false,
  });

  return data?.context?.identityKey ?? null;
};
